export { default as PhoneVerification } from '@src/features/customers/auth/phone-verification/components';
export { PhoneVerificationAlert } from '@src/features/customers/auth/phone-verification/components/Alert';
export { default as AccountPhoneVerification } from '@src/features/customers/auth/phone-verification/components/AccountVerification';
export { default as usePhoneVerification } from '@src/features/customers/auth/phone-verification/hooks/usePhoneVerification';
